import React from 'react'

import "./Title.css";

export const Title = () => {
  return (
    <h1 className='app-title'><span>X</span>Quicky</h1>
  )
}
